var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf"},[_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"100%","z-index":"7777","position":"absolute","top":"0"},attrs:{"src":_vm.src,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }